/* wnfsw-collection: progressive enhancement for the stack below the product grid. Every link works without this file.
   "Filter and sort" opens the theme's real filter drawer (#FilterDrawerTrigger). The store block's hours line gains an
   "Open now until 6 pm" style status from the posted hours (F06), suppressed on holidays until holiday hours are confirmed.
   "Send a photo" opens the site chat in place with the photo prompt (the link carries js-no-transition so the theme's
   page-transition handler does not follow its fallback href), "Read the whole guide" removes the phone-only clip and shows
   the jump links, and CTA clicks plus one-time view events go to GA4 only with analytics consent (pattern: wnf-financing.js). */
(() => {
  'use strict';
  if (window.wnfswCollectionInit) return;
  window.wnfswCollectionInit = true;
  const measurementId = 'G-0JE425EEKS';
  const root = () => document.querySelector('[data-wnfsw-collection-page]');
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  const track = (name, params = {}) => {
    const r = root();
    if (!r || !allowed() || typeof window.gtag !== 'function') return;
    window.gtag('event', name, { send_to: measurementId, collection_handle: r.dataset.wnfswCHandle, ...params });
  };
  if (!window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {});
  }
  const viewOnce = (el, name) => {
    if (!el || !('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver((entries) => {
      if (entries.some((e) => e.isIntersecting)) { io.disconnect(); track(name); }
    }, { threshold: 0.15 });
    io.observe(el);
  };
  // Posted hours for both showrooms (F06): Sun 11-5, Mon-Sat 10-6, America/Los_Angeles.
  const HOURS = [[11, 17], [10, 18], [10, 18], [10, 18], [10, 18], [10, 18], [10, 18]];
  const fmt = (hr) => (hr > 12 ? hr - 12 : hr) + (hr >= 12 ? ' pm' : ' am');
  // Holiday hours are unconfirmed, so the status is not shown on these days (static hours remain): Thanksgiving, Dec 24, Dec 25, Jan 1.
  const isHoliday = (y, m, d) => {
    if ((m === 12 && (d === 24 || d === 25)) || (m === 1 && d === 1)) return true;
    if (m === 11) { const first = new Date(Date.UTC(y, 10, 1)).getUTCDay(); const thanksgiving = 1 + ((4 - first + 7) % 7) + 21; return d === thanksgiving; }
    return false;
  };
  const openStatus = () => {
    try {
      const parts = Object.fromEntries(new Intl.DateTimeFormat('en-US', { timeZone: 'America/Los_Angeles', year: 'numeric', month: 'numeric', day: 'numeric', weekday: 'short', hour: 'numeric', minute: 'numeric', hourCycle: 'h23' })
        .formatToParts(new Date()).map((x) => [x.type, x.value]));
      const y = +parts.year, m = +parts.month, d = +parts.day;
      const day = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(parts.weekday);
      const now = (+parts.hour % 24) + (+parts.minute) / 60;
      if (day < 0 || isHoliday(y, m, d)) return null;
      const [open, close] = HOURS[day];
      if (now >= open && now < close) return 'Open now until ' + fmt(close) + '.';
      if (now < open) return 'Opens today at ' + fmt(open) + '.';
      const t = new Date(Date.UTC(y, m - 1, d + 1));
      if (isHoliday(t.getUTCFullYear(), t.getUTCMonth() + 1, t.getUTCDate())) return null;
      return 'Opens tomorrow at ' + fmt(HOURS[(day + 1) % 7][0]) + '.';
    } catch (e) { return null; }
  };
  const init = () => {
    const r = root();
    if (!r) return;
    const guide = r.querySelector('[data-wnfsw-c-guide]');
    // Observe small, early elements: the whole section is often taller than 1/0.15 viewports, so it could never reach 15%.
    viewOnce(r.querySelector('.wnfsw-c-shop'), 'wnf_collection_tail_view');
    viewOnce(r.querySelector('.wnfsw-c-guide-head'), 'wnf_collection_guide_view');
    const status = openStatus();
    if (status) r.querySelectorAll('[data-wnfsw-c-open]').forEach((el) => { el.textContent = status + ' '; el.hidden = false; });
    const phone = () => window.matchMedia('(max-width: 900px)').matches;
    const openDesc = (desc, reveal) => {
      if (!desc || desc.classList.contains('is-open')) return;
      desc.classList.add('is-open');
      if (guide) guide.classList.add('is-open');
      const btn = r.querySelector('[data-wnfsw-c-more][aria-controls="' + desc.id + '"]');
      if (btn) { btn.setAttribute('aria-expanded', 'true'); btn.dataset.more = btn.textContent; btn.textContent = btn.dataset.less || 'Show less'; }
      // On phones the jump links appear above the text once it opens; bring the heading into view so nothing jumps unseen.
      if (reveal && phone() && guide && guide.querySelector('.wnfsw-c-toc')) guide.querySelector('.wnfsw-c-guide-head').scrollIntoView({ block: 'start' });
    };
    // Capture phase, so this runs before the theme's own link handlers.
    r.addEventListener('click', (event) => {
      const more = event.target.closest('[data-wnfsw-c-more]');
      if (more) {
        const desc = document.getElementById(more.getAttribute('aria-controls'));
        if (desc.classList.contains('is-open')) {
          desc.classList.remove('is-open'); if (guide) guide.classList.remove('is-open');
          more.setAttribute('aria-expanded', 'false'); more.textContent = more.dataset.more || 'Read the whole guide';
          (guide || desc).scrollIntoView({ block: 'start' });
        } else { openDesc(desc, true); track('wnf_collection_guide_open'); }
        return;
      }
      const refine = event.target.closest('[data-wnfsw-c-refine]');
      if (refine) {
        const trigger = document.getElementById('FilterDrawerTrigger');
        // Stop this click before it reaches the drawer's click-outside-to-close handler, then open on the next tick.
        if (trigger) { event.preventDefault(); event.stopPropagation(); window.setTimeout(() => trigger.click(), 0); }
        track('wnf_collection_cta_click', { cta: 'refine', transport_type: 'beacon' });
        return;
      }
      const toc = event.target.closest('[data-wnfsw-c-toc]');
      if (toc) {
        const target = document.getElementById(toc.getAttribute('href').slice(1));
        openDesc(target && target.closest('[data-wnfsw-c-desc]'), false);
        track('wnf_collection_cta_click', { cta: 'guide_jump', transport_type: 'beacon' });
        return;
      }
      const cta = event.target.closest('[data-wnfsw-c-cta]');
      if (cta) track('wnf_collection_cta_click', { cta: cta.dataset.wnfswCCta, transport_type: 'beacon' });
      const chat = event.target.closest('[data-wnfsw-c-chat]');
      if (chat && typeof window.WNFChatOpen === 'function') {
        event.preventDefault();
        window.WNFChatOpen(chat.dataset.wnfswCChat === 'photo' ? { intent: 'photo' } : undefined);
        track('wnf_collection_chat_open', { intent: chat.dataset.wnfswCChat || 'general' });
      }
    }, true);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
